import * as React from "react";
const SvgFiRrFaceUnamused = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-unamused_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m6-11.5a1.495 1.495 0 0 1-2.908.5H14a1 1 0 0 1 0-2h2.5a1.5 1.5 0 0 1 1.5 1.5M7.092 11H6a1 1 0 0 1 0-2h2.5a1.5 1.5 0 0 1 0 3 1.495 1.495 0 0 1-1.408-1m8.505 6.198a1 1 0 1 1-1.194 1.604C14.396 18.797 13.289 18 12 18s-2.396.797-2.407.805a.999.999 0 0 1-1.19-1.607C8.469 17.149 10.035 16 12 16s3.531 1.149 3.597 1.198"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-unamused_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceUnamused;
